import {
    Autocomplete,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    styled,
  } from "@mui/material";
  import React, { memo, useEffect, useRef, useState } from "react";
  import moment from "moment";
  import _ from "lodash";
  import axios from "axios";
  import { useDispatch } from "react-redux";
  import { useStyle } from "../../master/style";
  import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { onPressButton, setThermalData } from "../../../../../components/hooks/printPdf/thermalData";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Helmet } from "react-helmet-async";
  
  const ExpensesClose = () => {
    const dispatch = useDispatch();
    const classes = useStyle();
    const amtRef = useRef(null);
    const outlet_id = localStorage.getItem("outlet_id");
    const [salesMan, setSalesMan] = useState([]); // salesman id
    const [sideBardata, setSideBarData] = useState([]);
    const outId = localStorage.getItem("outlet_id");
    const[balance , setBalance] = useState(0)
    const [totalAmount, setTotalAmount] = useState(0);
    const [closingBalance , setClosingBalance] = useState(0)
    const [companyData , setCompanyData] = useState([])
    const navigate = useNavigate()
    const roleId = localStorage.getItem("role_id")
    const [open , setOpen] = useState(false)
    const [errorMsg, setErrorMsg] = useState("");
    const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
    const [data1, setData1] = useState([]);
    const [poDetails, setPoDetails] = useState({
      fromDate : moment().format('YYYY-MM-DD'),
      toDate : moment().format('YYYY-MM-DD'),
      Date: moment().format(),
      salesManId: null,
    });
    const [dateLimit, setDateLimit] = useState({
      fromDate : moment().format(),
    })
    function handleChangeDate(e, name) {
      setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
    }
    const [salesID, setSalesID] = useState(null)
    const [postData, setPostData] = useState({
      date:moment(dateLimit.fromDate).format("YYYY-MM-DD"),
      opening_balance:balance,
      expences_amount:totalAmount,
      closing_balance:closingBalance,
      total_amount:0,
      outlet_id: outId,
      salesman_id: salesID===null ? null : salesID.id,
      closing_expences_details: [],
  
    });

    const [initialValue, setInitialValue] = useState([
      { note: 2000, nos: "", amt: "" },
      { note: 500, nos: "", amt: "" },
      { note: 200, nos: "", amt: "" },
      { note: 100, nos: "", amt: "" },
      { note: 50, nos: "", amt: "" },
      { note: 20, nos: "", amt: "" },
      { note: 10, nos: "", amt: "" },
      { note: 5, nos: "", amt: "" },
      { note: 2, nos: "", amt: "" },
      { note: 1, nos: "", amt: "" },
    ]);
    const [data, setData] = useState(initialValue);
    const [active, setActive] = useState(0);
    function handleChange(e, idx) {
      const value = e.target.value.replace(/[^0-9]/g, "").trim();
      const arr = [...data];
      setData([]);
    
      // Update the selected denomination count (nos) and amount (amt) based on value entered
      arr[idx].nos = value;
      arr[idx].amt = arr[idx].note * (value === "" ? 0 : parseFloat(value));
    
      // Clear amt if nos is empty
      arr.forEach((item) => {
        if (!item.nos.trim() && item.amt !== "0.00") {
          item.amt = "";
        }
      });
    
      // Update the state with the modified array
      setData(arr);
   if (errorMsg) {
        setErrorMsg("");
      }
    }
    
    // function handleChange(e, idx) {
    //   const value = e.target.value.replace(/[^0-9]/g, "").trim();
    //   const arr = [...data];
    //   setData([])
    //   // console.log(value, arr[idx])
    //     arr[idx].nos = value;
    //     arr[idx].amt = arr[idx].note *( value==="" ? 0 : parseFloat(value));
    //   // console.log(arr[idx].amt)
    //   arr.forEach((item) => {
    //     if (!item.nos.trim() && item.amt !== "0.00") {
    //       item.amt = "";
    //     }
    //   });
  
    //   // setData(arr);
    //   // if (errorMsg) {
    //   //   setErrorMsg("");
    //   // }else{
    //   //   setErrorMsg("Total Amount cannot exceed the Closing Balance");
    //   // }
    // }
  
    function handleKey(e) {
      if (e.key === "Enter" && data.length > active) {
        setActive((prev) => prev + 1);
        amtRef.current.focus();
      }
    }
    const handleSalesMan = (e, value) => {
      setPoDetails((prev) => ({ ...prev, salesManId: value }));
      // console.log(value)
      setSalesID(value)
    };
    let totalAmt = 0;
  
    data.forEach((item) => {
      if (item.amt !== "") {
        totalAmt += parseFloat(item.amt);
      } else {
        totalAmt += 0;
      }
    });
    // data.forEach((item) => {
    //   if (item.amt !== "") {
    //     totalAmt += parseFloat(item.amt);
    //   } else {
    //     totalAmt += 0;
    //   }
    // });
    useEffect(() => {
      axios.get(`/v1/outlet/info/${outId}`)
      .then((res) => {
        // console.log(res.data);
        setCompanyData(res.data)
      })
      .catch((err) => {console.log(err)})
        },[])
    const textData = {
      tot:parseFloat(totalAmt).toFixed(2),
      date:moment(dateLimit.fromDate).format("YYYY-MM-DD"),
      employee:poDetails.salesManId != null && poDetails.salesManId.sales_man_name,
      opening_balance:parseFloat(balance).toFixed(2),
      expences_amount:totalAmount
    }
    const tableData = _.map(postData.closing_expences_details, ((val , idx)=>({ 
      sno:++idx,
     denomination:val.denomination,
     count:val.count,
     total:val.total
    })))
    // const handleTotalCheck = () => {
    //   const closingBalance = parseFloat(balance); // Get the current closing balance
    //   if (totalAmount > closingBalance) {
    //     setErrorMsg("Total cannot exceed the Closing Balance");
    //   } else {
    //     setErrorMsg(""); // Clear any previous error
    //     // Call the function to submit data or handle the form as usual
    //     onCheck();
    //   }
    // };
    const handleTotalCheck = () => {
      const closingBalance = parseFloat(balance - totalAmount); // Get the current closing balance
      const denominationTotal = parseFloat(totalAmt);
    
      if (denominationTotal > closingBalance) {
        setErrorMsg("Total Amount cannot exceed the Closing Balance");
      } else {
        setErrorMsg(""); // Clear any previous error
        onCheck(); // Call the function to proceed
      }
    };
    
    console.log(closingBalance,"closingBalance");
    
    const onCheck = () => {
      if (poDetails.salesManId === null){
        dispatch(setSnackbar(true, "error", "Please Select Salesman"));
      }
      else{
        setOpen(true)
      }
    }
    // console.log("post method", postData);

    const onSave = () => {
      // if (poDetails.salesManId != null) {
        // console.log("post method", data, postData);
        axios
        .post(`/v1/closing_expences_master`, postData)
        .then((res) => {
          // console.log(res)
          setData(initialValue)
          dispatch(setSnackbar(true, 'success', "Expense Closed successfully"))
          // setTimeout(() => {
          //   window.location.reload();
          // },[1000])
        })
        .catch((err) => {
          console.log(err);
          dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
        });

        dispatch(setThermalData({
          tableData : tableData,
          TotalData : textData,
          companyInfo:companyData
        }))      
        dispatch(onPressButton())
        const name = `ExpenseBill`
        navigate(`/expenseClose/${name}`) 
  
      
    };
    console.log(postData)
    function getSalesMan() {
      axios
      .get(`v1/SalesMan/outlets/${outlet_id}`)
        .then((res) => setSalesMan(res.data))
        .catch((err) => console.log(err));
    }
   
    const openingBalanceChange = (e) => {
      const opBalance = e.target.value.replace(/[^0-9]/g, '')
      setBalance(opBalance)
    }
    const onClosingBalance = (e) => {
      const closeBalance = e.target.value.replace(/[^0-9]/g, '')
      setClosingBalance(closeBalance)
    }
    
    const sideExpensesData = () => {
        // const postExpense = {
        //     from_date : moment().subtract(1,'months').format('YYYY-MM-DD'),
        //     to_date : moment().format('YYYY-MM-DD'),
        //     docno :  0
        // }
        axios
        .get(`/v1/outlet_expences/${moment(dateLimit.fromDate).format("YYYY-MM-DD")}/${moment(dateLimit.fromDate).format("YYYY-MM-DD")}/${outId}`)
        .then((res) => {
          // console.log(res);
          setSideBarData(res.data);
        })
        .catch((err) => {
          console.log(err);
          dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
        });
    }
    useEffect(() => {
      getSalesMan();
    },[])
    useEffect(() => {
      sideExpensesData()
    }, [dateLimit]);
    const today = moment().format('YYYY-MM-DD');
    console.log("today",today)
    // const filteredData = _.filter(sideBardata, value => moment(value.docdate).format('YYYY-MM-DD') == today);
    useEffect(() => {
      const total = _.sumBy(sideBardata, value => parseFloat(value.amount));
      setTotalAmount(total.toFixed(2));
  }, [sideBardata]);
    useEffect(()=>{
      if(salesID){
          setPostData(prev=>({...prev, salesman_id: salesID.id}))
      }},[salesID,dateLimit])
    useEffect(()=>{
      const postingData = data
      .filter(item => item.nos !== "" && item.amt !== "")
      .map(item => ({
        denomination: item.note,
        count: parseInt(item.nos),
        total: parseFloat(item.amt),
        date: moment().format("YYYY-MM-DD"),
        outlet_id: outId,
        salesman_id:salesID===null ? null : salesID.id,
      }));
      // console.log(postingData)
      setPostData(prev=>({...prev,date:moment(dateLimit.fromDate).format("YYYY-MM-DD"), closing_expences_details: postingData ,total_amount:parseFloat(totalAmt).toFixed(2) ,
        expences_amount:totalAmount,
        closing_balance:parseFloat(balance - totalAmount).toFixed(2),
        opening_balance:balance
      }))
    },[data, salesID,sideBardata,balance,closingBalance,totalAmount,dateLimit])

    // const getBalanceValue = () => {
    //   const baldata = {
    //     date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
    //     outlet_id: outId,
    //   };
  
    //   axios.post(`/v1/closing_expences_master/getOne`, baldata)
    //     .then((res) => {
    //       if (res.data.length > 0) {
    //         const closingLines = res.data[0].closing_expences_lines || [];
    //         setBalance(res.data[0].opening_balance);
    //         updateInitialValue(closingLines); // Call the function to update initial value
    //       }
    //     })
    //     .catch((err) => {
    //       console.error("Error fetching balance value:", err);
    //     });
    // };
    const getBalanceValue = () => {
      const baldata = {
        date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
        outlet_id: outId,
      };
  
      axios.post(`/v1/closing_expences_master/getOne`, baldata)
        .then((res) => {
          if (res.data.length > 0) {
            // const closingLines = res.data[0].closing_expences_lines || [];
            const closingLines = res.data[0].closing_expences_lines || [];
            const openingBalance = res.data[0].opening_balance || 0;
            const total_Amountbutton = res.data[0].total_amount || 0;

            // Update the state with the fetched data
            setData(initialValue.map(item => {
              const matched = closingLines.find(line => line.denomination === item.note);
              return matched
                ? { ...item, nos: matched.count, amt: matched.total }
                : item;
            }));

        // setBalance(openingBalance);
        // setTotalAmount(_.sumBy(closingLines, 'total').toFixed(2));
            setBalance(res.data[0].opening_balance);
            updateInitialValue(closingLines); // Call the function to update initial value
            setData1(total_Amountbutton)

          }else{
             // Reset data if no closing expenses found
        setData(initialValue);
        
        setBalance(0);
        setTotalAmount(0);
          }
        })
        .catch((err) => {
          setData(initialValue.map(item => ({ ...item, nos: '', amt: '' })));

          console.error("Error fetching balance value:", err);
        });
    };
    const updateInitialValue = (closingLines) => {
      const updatedValues = initialValue.map((denom) => {
        const line = closingLines.find(line => line.denomination === denom.note);
        if (line) {
          return {
            ...denom,
            nos: line.count,  // Use the count from closing lines
            amt: (line.denomination * line.count).toFixed(2), // Calculate total amount
          // amt: line.denomination
          };
        }
        return denom; // Return original denomination if no match found
      });
  
      setInitialValue(updatedValues); // Update state with new values
    };
   useEffect(() => {
    getBalanceValue()
   },[outId , dateLimit])
 useEffect(() => {
  axios.get(`/v1/outlet/info/${outId}`)
  .then((res) => {console.log(res.data.wallet_balance);setBalance(res.data.wallet_balance)})
  .catch((err) => {console.log(err)})
 },[outId])
 console.log(data1,today,"testlenth")
  //  console.log(balance)
  //  console.log(totalAmount)
  //  console.log(parseFloat((balance - totalAmount).toFixed(2)))
    return (
      <Grid className="bg-white relative ">
        <Grid
          className="flex justify-between items-center px-2"
          sx={{ marginBlockEnd: 1 }}
        >
          <Helmet>
                <title>
                Expenses Close
                </title>
              </Helmet>
          <div>
            <Typography className={classes.titleCashClose}>Expenses Close</Typography>
          </div>
          <Grid className="flex-1">
            <Autocomplete
              id="salesman"
              name="salesman"
              size="small"
              options={salesMan}
              getOptionLabel={(option) =>
                `${option.sales_man_name} - ${option.sales_man_code}`
              }
              value={poDetails.salesManId}
              onChange={handleSalesMan}
              disableClearable
              isOptionEqualToValue={(option, value) => option.id === value.id}
              sx={{ marginBlock: 1, width: "250px",marginInline:1 }}
              fullWidth
              renderInput={(params) => (
                <TextField {...params} label="Salesman" autoComplete="off" />
              )}
            />
          </Grid>
          <div className="flex items-center">
            {/* <Typography>Date</Typography>
            <TextField
              size="small"
              sx={{ marginInline: 2 }}
              value={moment().format("DD-MM-YYYY")}
            /> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* <DatePicker
              onChange={(e) => handleChangeDate(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              // disabled={roleId != 1 && roleId != 2}
              // minDate={roleId === 1 && roleId === 2 ? null : dayjs()}
              //  maxDate={dayjs()}
               slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'},
                },
              }}
            /> */}

           <DatePicker
                         onChange={(e) => handleChangeDate(e, "fromDate")}
                         value={dayjs(dateLimit.fromDate)}
                         format="DD-MM-YYYY"
                         disabled={roleId != 1 && roleId != 2} 
                         maxDate={dayjs()} 
                         slotProps={{
                           textField: {
                             size: "small",
                             label:'From',
                             style:{width : '100%'},
                           },
                         }}
            />
     {/* <DatePicker
              onChange={(e) => handleChangeDate(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              // disabled={roleId != 1 && roleId != 2}
              disabled={roleId !== 1 && roleId !== 2 ? null : dayjs()}
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'},
                },
              }}
            /> */}
          </LocalizationProvider>
          </div>
        </Grid>
        <Grid container>
          <Grid item xs={12} sm={6} md={6}>
            <TableContainer
              className={classes.tblRoot}
              sx={{ maxWidth: "70%", margin: "0 auto" }}
            >
              <Table>
                <TableHead className={classes.tblHeader}>
                  <TableRow>
                    <TableCell
                      sx={{
                        borderRight: "0.5px solid  #ccc",
                        textAlign: "center",
                      }}
                    >
                      Notes
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: "0.5px solid  #ccc",
                        textAlign: "center",
                      }}
                    >
                      Nos
                    </TableCell>
                    <TableCell>Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(data, (val, idx) => (
                    <TableRow key={val.note} className={classes.tablrow} onClick={() => setActive(idx)}>
                      <TableCell sx={{ borderRight: `1px solid #ccc` , }}className={classes.tblHeadCell}>{val.note}</TableCell>
                      <TableCell sx={{ borderRight: `1px solid #ccc` ,}}>
                          <TextField
                          size="small"
                          autoComplete="off"
                          value={val.nos}
                          // disabled={roleId != 1 && roleId != 2}
                          onKeyPress={(e) => handleKey(e, idx)}
                          inputRef={active === idx ? amtRef : null}
                          InputProps={{
                            style: {
                              maxHeight: "10px",
                              outline: "none",
                              fontSize: 14,
                            },
                          }}
                          inputProps={{ style: { textAlign: "right" } }}
                          className={classes.tableInput}
                          onChange={(e) => handleChange(e, idx)}
                        />
                      </TableCell>
  
                      <TableCell align="right" padding="checkbox"sx={{ minWidth: 130, fontWeight: 700, padding: 0,height:"25px" }}>
                        <Typography fontWeight={700} textAlign="right">{val.amt !== "" && parseFloat(val.amt).toFixed(2)}</Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow className={classes.tablrow} sx={{padding:0}}>
                    <TableCell sx={{ borderRight: `1px solid #ccc` }} />
                    <TableCell />
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{padding:"7px",height:"15px" ,borderLeft:"1px solid #ccc"}} colSpan={2}>Total</TableCell>
                    <TableCell
                      sx={{
                        borderLeft: `1px solid #ccc`,
                        textAlign: "right",
                        fontWeight: 700,
                        padding:"7px",height:"15px"
                      }}
                    >
                      {parseFloat(totalAmt).toFixed(2)}
                    </TableCell>
                  </TableRow>
                
                </TableBody>
              </Table>
            </TableContainer>
            {errorMsg && <Typography color="error" className="my-2 flex justify-center">{errorMsg}</Typography>}
            {/* <Typography color="error" className="my-2 flex justify-center">{errorMsg}</Typography> */}
            <Grid className="my-2 flex justify-center">
            
              
              {/* <Button  onClick={handleTotalCheck}  
                //  disabled={
                //   data1 > 0 || 
                //   !today || 
                //   postData.closing_expences_details.length === 0
                // }
                // sx={{
                //   backgroundColor: 
                //     data1 > 0 || 
                //     !today || 
                //     postData.closing_expences_details.length === 0 
                //       ? "#ccc" 
                //       : "#A06EE1",
                //   color: "#fff !important",
                //   '&:hover': {
                //     backgroundColor: 
                //       data1 > 0 || 
                //       !today || 
                //       postData.closing_expences_details.length === 0 
                //         ? 'darkgrey' 
                //         : '#A06EE1',
                //   }
                // }}

                // for enabling submit button for previous date expenses close and previous data enter
              disabled={
       (roleId != 1 && roleId != 2) ||
       (
      moment(dateLimit.fromDate).isSame(today, 'day') && data1 > 0
       ) ||
       postData.closing_expences_details.length === 0
      }
      sx={{
    backgroundColor:
      (roleId != 1 && roleId != 2) ||
      (
        moment(dateLimit.fromDate).isSame(today, 'day') && data1 > 0
      ) ||
      postData.closing_expences_details.length === 0
        ? "#ccc"
        : "#A06EE1",
    color: "#fff !important",
    "&:hover": {
      backgroundColor:
        (roleId != 1 && roleId != 2) ||
        (
          moment(dateLimit.fromDate).isSame(today, 'day') && data1 < 0
        ) ||
        postData.closing_expences_details.length === 0
          ? "darkgrey"
          : "#A06EE1",
    },
  }}
            //   disabled={postData.closing_expences_details.length === 0 } 
            //   sx={{backgroundColor: postData.closing_expences_details.length === 0 ? "#ccc" :"#A06EE1",color:"#fff !important",'&:hover': {
            //   backgroundColor: postData.closing_expences_details.length === 0 ? 'darkgrey' : '#A06EE1', }}}
            //  disabled={ !isSubmitEnabled || sideBardata.length === 0 || !isSubmitEnabled} sx={{backgroundColor: sideBardata.length === 0 || !isSubmitEnabled ? "grey" :"#A06EE1",color:"#fff !important",'&:hover': {
            //  backgroundColor: sideBardata.length === 0 || !isSubmitEnabled ? 'darkgrey' : '#A06EE1', }}}
        >
                Submit
              </Button> */}
         

      {/* <Button
        onClick={handleTotalCheck}
        disabled={(() => {
          const selectedDate = dayjs(postData?.date);
          const today = dayjs();
          const yesterday = today.subtract(1, "day");

          // ❌ Disable if no details or data1 <= 0
          if (postData.closing_expences_details.length === 0 || data1 <= 0) {
            return true;
          }

          if (roleId === 1 || roleId === 2) {
            // ✅ Admins: allow today & yesterday
            return !(
              selectedDate.isSame(today, "day") ||
              selectedDate.isSame(yesterday, "day")
            );
          } else {
            // ✅ Others: allow only today
            return !selectedDate.isSame(today, "day");
          }
        })()}
        sx={{
          backgroundColor: (() => {
            const selectedDate = dayjs(postData?.date);
            const today = dayjs();
            const yesterday = today.subtract(1, "day");

            const isDateAllowed =
              (roleId === 1 || roleId === 2)
                ? selectedDate.isSame(today, "day") || selectedDate.isSame(yesterday, "day")
                : selectedDate.isSame(today, "day");

                console.log("today:", today.format("DD-MM-YYYY"));
                console.log("yesterday:", yesterday.format("DD-MM-YYYY"));

            const isEnabled =
              data1 > 0 &&
              postData.closing_expences_details.length > 0 &&
              isDateAllowed;

            return isEnabled ? "#A06EE1" : "grey";
          })(),
          color: "#fff !important",
          "&:hover": {
            backgroundColor: (() => {
              const selectedDate = dayjs(postData?.date);
              const today = dayjs();
              const yesterday = today.subtract(1, "day");

              const isDateAllowed =
                (roleId === 1 || roleId === 2)
                  ? selectedDate.isSame(today, "day") || selectedDate.isSame(yesterday, "day")
                  : selectedDate.isSame(today, "day");

              const isEnabled =
                data1 > 0 &&
                postData.closing_expences_details.length > 0 &&
                isDateAllowed;

              return isEnabled ? "#A06EE1" : "darkgrey";
            })(),
          },
        }}
      >
        Submit
      </Button> */}
      {/* <Button
  onClick={handleTotalCheck}
  disabled={(() => {
    const selectedDate = dayjs(postData?.date);
    const today = dayjs();
    const yesterday = today.subtract(1, "day");

    // ❌ Disable if no details or data1 <= 0
    if (postData.closing_expences_details.length === 0 || data1 <= 0) {
      return true;
    }

    if (roleId === 1 || roleId === 2) {
      // ✅ Admins: allow today & yesterday
      return !(
        selectedDate.isSame(today, "day") ||
        selectedDate.isSame(yesterday, "day")
      );
    } else {
      // ✅ Others: allow only today
      return !selectedDate.isSame(today, "day");
    }
  })()}
  sx={{
    backgroundColor: (() => {
      const selectedDate = dayjs(postData?.date);
      const today = dayjs();
      const yesterday = today.subtract(1, "day");

      const isDateAllowed =
        (roleId === 1 && roleId === 2)
          ? selectedDate.isSame(today, "day") || selectedDate.isSame(yesterday, "day")
          : selectedDate.isSame(today, "day");

      const isEnabled =
        data1 > 0 &&
        postData.closing_expences_details.length > 0 &&
        isDateAllowed;

      return isEnabled ? "#A06EE1" : "grey";
    })(),
    color: "#fff !important",
    "&:hover": {
      backgroundColor: (() => {
        const selectedDate = dayjs(postData?.date);
        const today = dayjs();
        const yesterday = today.subtract(1, "day");

        const isDateAllowed =
          (roleId === 1 && roleId === 2)
            ? selectedDate.isSame(today, "day") || selectedDate.isSame(yesterday, "day")
            : selectedDate.isSame(today, "day");

        const isEnabled =
          data1 > 0 &&
          postData.closing_expences_details.length > 0 &&
          isDateAllowed;

        return isEnabled ? 'darkgrey' : '#A06EE1';
      })(),
    },
  }}
>
  Submit
</Button> */}

         <Button 
          onClick={handleTotalCheck} 
          disabled={
         (roleId !== 1 && roleId !== 2 && 
         moment(dateLimit.fromDate).isSame(today, 'day') && data1 > 0) &&
         postData.closing_expences_details.length === 0
          } 
         sx={{
         backgroundColor:
         (roleId !== 1 && roleId !== 2 && 
        moment(dateLimit.fromDate).isSame(today, 'day') || data1 > 0) &&
        postData.closing_expences_details.length === 0
        ? "#ccc"
        : "#A06EE1",
        color: "#fff !important",
        "&:hover": {
        backgroundColor:
        (roleId !== 1 && roleId !== 2 && 
          moment(dateLimit.fromDate).isSame(today, 'day') && data1 < 0) &&
        postData.closing_expences_details.length === 0
          ? "darkgrey"
          : "#A06EE1",
       },
     }}
       >
      Submit
      </Button>
     

            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
          <TableContainer className={classes.tblRoot} >
            <Table className={classes.table}>
                <TableHead className={classes.tblHeader} sx={{backgroundColor:"#A06EE1",color:"#fff"}}>
                    <TableRow className={classes.tablrow} sx={{color:"#fff"}}>
                    <TableCell className={classes.tblCell} sx={{color:"#fff"}}>S.No</TableCell>
                    <TableCell className={classes.tblCell} sx={{color:"#fff"}}>Date</TableCell>
                        <TableCell className={classes.tblCell} sx={{color:"#fff"}}>Bill No</TableCell>
                        <TableCell className={classes.tblCell} sx={{color:"#fff"}}>Account Name</TableCell>
                        <TableCell className={classes.tblCell} sx={{color:"#fff"}}>remarks</TableCell>
                        <TableCell className={classes.tblCell} sx={{color:"#fff"}}>Amount</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody >
                {
                sideBardata.length > 0 ? (
                    _.map(sideBardata, (value, idx) => (
                        <TableRow className={classes.tablrow} key={idx}>
                            <TableCell sx={{ borderLeft: "1px solid #ccc" }}>{idx + 1}</TableCell>
                            <TableCell>{moment(value.docdate).format('DD-MM-YYYY')}</TableCell>
                            <TableCell>{value.docno.replace(/_/g, "/")}</TableCell>
                            <TableCell>{value.account_name}</TableCell>
                            <TableCell>{value.remarks}</TableCell>
                            <TableCell sx={{ fontWeight: 600, textAlign: "right !important" }}>
                                {parseFloat(value.amount).toFixed(2)}
                            </TableCell>
                        </TableRow>
                    ))
                ) : (
                    <TableRow>
                        <TableCell colSpan={6} sx={{ textAlign: 'center' }}>
                            No data found for today
                        </TableCell>
                    </TableRow>
                )
            }

                </TableBody>
            </Table>
        </TableContainer>
        <div
              style={{
                paddingInline: 5,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                marginBlock:2,
                justifyContent:"center"
              }}
            >
                  <Grid className={classes.flexCorrection}>
                <Typography fontWeight={600}>Opening Balance</Typography>
                <TextField
                  size="small"
                  className={classes.TextFieldCash}
                  inputProps={{
                    style: {
                      color: "#fff",
                      textAlign: "right",
                      fontWeight: "bold",
                    }, 
                  }}
                  InputProps={{
                    readOnly: true,
                  }} 
                  sx={{ backgroundColor: "#B57EDC" }}
                  value={parseFloat(balance).toFixed(2)}
                  onChange={openingBalanceChange}
                />
              </Grid>
              <Grid className={classes.flexCorrection}>
                <Typography fontWeight={600}>Expenses Amount</Typography>
                <TextField
                  size="small"
                  className={classes.TextFieldCash}
                  inputProps={{
                    style: {
                      color: "#fff",
                      textAlign: "right",
                      fontWeight: "bold",
                    }, // Set text color to white
                  }}
                  InputProps={{
                    readOnly: true,
                  }} 
                  sx={{ backgroundColor: "#B57EDC" }}
                  value={totalAmount}
                />
              </Grid>
          
              <Grid className={classes.flexCorrection}>
                <Typography fontWeight={600}>Closing Balance</Typography>
                <TextField
                  size="small"
                  className={classes.TextFieldCash}
                  inputProps={{
                    style: {
                      color: "#fff",
                      textAlign: "right",
                      fontWeight: "bold",
                    }, 
                  }}
                  InputProps={{
                    readOnly: true,
                  }} 
                  sx={{ backgroundColor: "#B57EDC" }}
                  value={parseFloat((balance) - totalAmount).toFixed(2)}
                  onChange={onClosingBalance}
                />
              </Grid>
              </div>
          
          </Grid>
        </Grid>
        <Dialog open={open}>
      <DialogTitle>Cash CLose</DialogTitle>
      <DialogContent>
        <Typography>Are you sure want to close the Expense</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => setOpen(false)}>No</Button>
        <Button variant="contained" onClick={onSave}>Yes</Button>
      </DialogActions>
      </Dialog>
      </Grid>
    );
  };
  
  export default memo(ExpensesClose);
  
// import {
//   Autocomplete,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Divider,
//   Grid,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TextField,
//   Typography,
//   styled,
// } from "@mui/material";
// import React, { memo, useEffect, useRef, useState } from "react";
// import moment from "moment";
// import _ from "lodash";
// import axios from "axios";
// import { useDispatch } from "react-redux";
// import { useStyle } from "../../master/style";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import { onPressButton, setThermalData } from "../../../../../components/hooks/printPdf/thermalData";
// import { useNavigate } from "react-router-dom";
// import dayjs from "dayjs";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// const ExpensesClose = () => {
//   const dispatch = useDispatch();
//   const classes = useStyle();
//   const amtRef = useRef(null);
//   const outlet_id = localStorage.getItem("outlet_id");
//   const [salesMan, setSalesMan] = useState([]); // salesman id
//   const [sideBardata, setSideBarData] = useState([]);
//   const outId = localStorage.getItem("outlet_id");
//   const[balance , setBalance] = useState(0)
//   const [totalAmount, setTotalAmount] = useState(0);
//   const [closingBalance , setClosingBalance] = useState(0)
//   const [companyData , setCompanyData] = useState([])
//   const navigate = useNavigate()
//   const roleId = localStorage.getItem("role_id")
//   const [open , setOpen] = useState(false)
//   const [errorMsg, setErrorMsg] = useState("");

//   const [poDetails, setPoDetails] = useState({
//     fromDate : moment().format('YYYY-MM-DD'),
//     toDate : moment().format('YYYY-MM-DD'),
//     Date: moment().format(),
//     salesManId: null,
//   });
//   const [dateLimit, setDateLimit] = useState({
//     fromDate : moment().format(),
//   })
//   function handleChangeDate(e, name) {
//     setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
//   }
//   const [salesID, setSalesID] = useState(null)
//   const [postData, setPostData] = useState({
//     date:moment(dateLimit.fromDate).format("YYYY-MM-DD"),
//     opening_balance:balance,
//     expences_amount:totalAmount,
//     closing_balance:closingBalance,
//     total_amount:0,
//     outlet_id: outId,
//     salesman_id: salesID===null ? null : salesID.id,
//     closing_expences_details: [],

//   });

//   const [initialValue, setInitialValue] = useState([
//     { note: 2000, nos: "", amt: "" },
//     { note: 500, nos: "", amt: "" },
//     { note: 200, nos: "", amt: "" },
//     { note: 100, nos: "", amt: "" },
//     { note: 50, nos: "", amt: "" },
//     { note: 20, nos: "", amt: "" },
//     { note: 10, nos: "", amt: "" },
//     { note: 5, nos: "", amt: "" },
//     { note: 2, nos: "", amt: "" },
//     { note: 1, nos: "", amt: "" },
//   ]);
//   const [data, setData] = useState(initialValue);
//   const [active, setActive] = useState(0);
// //   function handleChange(e, idx) {
// //     const value = e.target.value.replace(/[^0-9]/g, "").trim();
// //     const arr = [...data];
// //     setData([]);
  
// //     // Update the selected denomination count (nos) and amount (amt) based on value entered
// //     arr[idx].nos = value;
// //     arr[idx].amt = arr[idx].note * (value === "" ? 0 : parseFloat(value));
  
// //     // Clear amt if nos is empty
// //     arr.forEach((item) => {
// //       if (!item.nos.trim() && item.amt !== "0.00") {
// //         item.amt = "";
// //       }
// //     });
  
// //     // Update the state with the modified array
// //     setData(arr);
// //  if (errorMsg) {
// //       setErrorMsg("");
// //     }
// //   }
// function handleChange(e, idx) {
//   // Extract the numeric value from the input field
//   const value = e.target.value.replace(/[^0-9]/g, "").trim();

//   // Make a copy of the existing data array
//   const arr = [...data];

//   // If there is a previous value, we allow editing but prevent entering non-numeric characters.
//   arr[idx].nos = value;

//   // Update the amount (amt) based on the updated count (nos)
//   arr[idx].amt = arr[idx].note * (value === "" ? 0 : parseFloat(value));

//   // Update the state with the modified array
//   setData(arr);

//   // Clear the error message if any
//   if (errorMsg) {
//     setErrorMsg("");
//   }
// }
//   // function handleChange(e, idx) {
//   //   const value = e.target.value.replace(/[^0-9]/g, "").trim();
//   //   const arr = [...data];
//   //   setData([])
//   //   // console.log(value, arr[idx])
//   //     arr[idx].nos = value;
//   //     arr[idx].amt = arr[idx].note *( value==="" ? 0 : parseFloat(value));
//   //   // console.log(arr[idx].amt)
//   //   arr.forEach((item) => {
//   //     if (!item.nos.trim() && item.amt !== "0.00") {
//   //       item.amt = "";
//   //     }
//   //   });

//   //   // setData(arr);
//   //   // if (errorMsg) {
//   //   //   setErrorMsg("");
//   //   // }else{
//   //   //   setErrorMsg("Total Amount cannot exceed the Closing Balance");
//   //   // }
//   // }

//   function handleKey(e) {
//     if (e.key === "Enter" && data.length > active) {
//       setActive((prev) => prev + 1);
//       amtRef.current.focus();
//     }
//   }
//   const handleSalesMan = (e, value) => {
//     setPoDetails((prev) => ({ ...prev, salesManId: value }));
//     // console.log(value)
//     setSalesID(value)
//   };
//   let totalAmt = 0;

//   initialValue.forEach((item) => {
//     if (item.amt !== "") {
//       totalAmt += parseFloat(item.amt);
//     } else {
//       totalAmt += 0;
//     }
//   });
//   // data.forEach((item) => {
//   //   if (item.amt !== "") {
//   //     totalAmt += parseFloat(item.amt);
//   //   } else {
//   //     totalAmt += 0;
//   //   }
//   // });
//   useEffect(() => {
//     axios.get(`/v1/outlet/info/${outId}`)
//     .then((res) => {
//       // console.log(res.data);
//       setCompanyData(res.data)
//     })
//     .catch((err) => {console.log(err)})
//       },[])
//   const textData = {
//     tot:parseFloat(totalAmt).toFixed(2),
//     date:moment(dateLimit.fromDate).format("YYYY-MM-DD"),
//     employee:poDetails.salesManId != null && poDetails.salesManId.sales_man_name,
//     opening_balance:parseFloat(balance).toFixed(2),
//     expences_amount:totalAmount
//   }
//   const tableData = _.map(postData.closing_expences_details, ((val , idx)=>({ 
//     sno:++idx,
//    denomination:val.denomination,
//    count:val.count,
//    total:val.total
//   })))
//   // const handleTotalCheck = () => {
//   //   const closingBalance = parseFloat(balance); // Get the current closing balance
//   //   if (totalAmount > closingBalance) {
//   //     setErrorMsg("Total cannot exceed the Closing Balance");
//   //   } else {
//   //     setErrorMsg(""); // Clear any previous error
//   //     // Call the function to submit data or handle the form as usual
//   //     onCheck();
//   //   }
//   // };
//   const handleTotalCheck = () => {
//     const closingBalance = parseFloat(balance); // Get the current closing balance
//     const denominationTotal = parseFloat(totalAmt);
  
//     if (denominationTotal > closingBalance) {
//       setErrorMsg("Total Amount cannot exceed the Closing Balance");
//     } else {
//       setErrorMsg(""); // Clear any previous error
//       onCheck(); // Call the function to proceed
//     }
//   };
  
  
//   const onCheck = () => {
//     if (poDetails.salesManId === null){
//       dispatch(setSnackbar(true, "error", "Please Select Salesman"));
//     }
//     else{
//       setOpen(true)
//     }
//   }
//   // console.log("post method", postData);

//   const onSave = () => {
//     // if (poDetails.salesManId != null) {
//       // console.log("post method", data, postData);
//       axios
//       .post(`/v1/closing_expences_master`, postData)
//       .then((res) => {
//         // console.log(res)
//         setData(initialValue)
//         dispatch(setSnackbar(true, 'success', "Expense Closed successfully"))
//         // setTimeout(() => {
//         //   window.location.reload();
//         // },[1000])
//       })
//       .catch((err) => {
//         console.log(err);
//         dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
//       });

//       dispatch(setThermalData({
//         tableData : tableData,
//         TotalData : textData,
//         companyInfo:companyData
//       }))      
//       dispatch(onPressButton())
//       const name = `ExpenseBill`
//       navigate(`/expenseClose/${name}`) 

    
//   };
//   console.log(postData)
//   function getSalesMan() {
//     axios
//     .get(`v1/SalesMan/outlets/${outlet_id}`)
//       .then((res) => setSalesMan(res.data))
//       .catch((err) => console.log(err));
//   }
 
//   const openingBalanceChange = (e) => {
//     const opBalance = e.target.value.replace(/[^0-9]/g, '')
//     setBalance(opBalance)
//   }
//   const onClosingBalance = (e) => {
//     const closeBalance = e.target.value.replace(/[^0-9]/g, '')
//     setClosingBalance(closeBalance)
//   }
  
//   const sideExpensesData = () => {
//       // const postExpense = {
//       //     from_date : moment().subtract(1,'months').format('YYYY-MM-DD'),
//       //     to_date : moment().format('YYYY-MM-DD'),
//       //     docno :  0
//       // }
//       axios
//       .get(`/v1/outlet_expences/${moment(dateLimit.fromDate).format("YYYY-MM-DD")}/${moment(dateLimit.fromDate).format("YYYY-MM-DD")}/${outId}`)
//       .then((res) => {
//         // console.log(res);
//         setSideBarData(res.data);
//       })
//       .catch((err) => {
//         console.log(err);
//         dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
//       });
//   }
//   useEffect(() => {
//     getSalesMan();
//   },[])
//   useEffect(() => {
//     sideExpensesData()
//   }, [dateLimit]);
//   const today = moment().format('YYYY-MM-DD');
//   // const filteredData = _.filter(sideBardata, value => moment(value.docdate).format('YYYY-MM-DD') == today);
//   useEffect(() => {
//     const total = _.sumBy(sideBardata, value => parseFloat(value.amount));
//     setTotalAmount(total.toFixed(2));
// }, [sideBardata]);
//   useEffect(()=>{
//     if(salesID){
//         setPostData(prev=>({...prev, salesman_id: salesID.id}))
//     }},[salesID,dateLimit])
//   useEffect(()=>{
//     const postingData = data
//     .filter(item => item.nos !== "" && item.amt !== "")
//     .map(item => ({
//       denomination: item.note,
//       count: parseInt(item.nos),
//       total: parseFloat(item.amt),
//       date: moment().format("YYYY-MM-DD"),
//       outlet_id: outId,
//       salesman_id:salesID===null ? null : salesID.id,
//     }));
//     // console.log(postingData)
//     setPostData(prev=>({...prev,date:moment(dateLimit.fromDate).format("YYYY-MM-DD"), closing_expences_details: postingData ,total_amount:parseFloat(totalAmt).toFixed(2) ,
//       expences_amount:totalAmount,
//       closing_balance:parseFloat(balance - totalAmount).toFixed(2),
//       opening_balance:balance
//     }))
//   },[data, salesID,sideBardata,balance,closingBalance,totalAmount,dateLimit])

//   const getBalanceValue = () => {
//     const baldata = {
//       date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
//       outlet_id: outId,
//     };

//     axios.post(`/v1/closing_expences_master/getOne`, baldata)
//       .then((res) => {
//         if (res.data.length > 0) {
//           const closingLines = res.data[0].closing_expences_lines || [];
//           setBalance(res.data[0].opening_balance);
//           updateInitialValue(closingLines); // Call the function to update initial value
//         }
//       })
//       .catch((err) => {
//         console.error("Error fetching balance value:", err);
//       });
//   };
//   const updateInitialValue = (closingLines) => {
//     const updatedValues = initialValue.map((denom) => {
//       const line = closingLines.find(line => line.denomination === denom.note);
//       if (line) {
//         return {
//           ...denom,
//           nos: line.count,  // Use the count from closing lines
//           amt: (line.denomination * line.count).toFixed(2), // Calculate total amount
//         // amt: line.denomination
//         };
//       }
//       return denom; // Return original denomination if no match found
//     });

//     setInitialValue(updatedValues); // Update state with new values
//   };
//  useEffect(() => {
//   getBalanceValue()
//  },[outId , dateLimit])
// useEffect(() => {
// axios.get(`/v1/outlet/info/${outId}`)
// .then((res) => {console.log(res.data.wallet_balance);setBalance(res.data.wallet_balance)})
// .catch((err) => {console.log(err)})
// },[outId])
// //  console.log(balance)
// //  console.log(totalAmount)
// //  console.log(parseFloat((balance - totalAmount).toFixed(2)))
//   return (
//     <Grid className="bg-white relative ">
//       <Grid
//         className="flex justify-between items-center px-2"
//         sx={{ marginBlockEnd: 1 }}
//       >
//         <div>
//           <Typography className={classes.titleCashClose}>Expenses Close</Typography>
//         </div>
//         <Grid className="flex-1">
//           <Autocomplete
//             id="salesman"
//             name="salesman"
//             size="small"
//             options={salesMan}
//             getOptionLabel={(option) =>
//               `${option.sales_man_name} - ${option.sales_man_code}`
//             }
//             value={poDetails.salesManId}
//             onChange={handleSalesMan}
//             disableClearable
//             isOptionEqualToValue={(option, value) => option.id === value.id}
//             sx={{ marginBlock: 1, width: "250px",marginInline:1 }}
//             fullWidth
//             renderInput={(params) => (
//               <TextField {...params} label="Salesman" autoComplete="off" />
//             )}
//           />
//         </Grid>
//         <div className="flex items-center">
//           {/* <Typography>Date</Typography>
//           <TextField
//             size="small"
//             sx={{ marginInline: 2 }}
//             value={moment().format("DD-MM-YYYY")}
//           /> */}
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//           <DatePicker
//             onChange={(e) => handleChangeDate(e, "fromDate")}
//             value={dayjs(dateLimit.fromDate)}
//             format="DD-MM-YYYY"
//             // disabled={roleId != 1 && roleId != 2} 
//             slotProps={{
//               textField: {
//                 size: "small",
//                 label:'From',
//                 style:{width : '100%'},
//               },
//             }}
//           />
//         </LocalizationProvider>
//         </div>
//       </Grid>
//       <Grid container>
//         <Grid item xs={12} sm={6} md={6}>
//           <TableContainer
//             className={classes.tblRoot}
//             sx={{ maxWidth: "70%", margin: "0 auto" }}
//           >
//             <Table>
//               <TableHead className={classes.tblHeader}>
//                 <TableRow>
//                   <TableCell
//                     sx={{
//                       borderRight: "0.5px solid  #ccc",
//                       textAlign: "center",
//                     }}
//                   >
//                     Notes
//                   </TableCell>
//                   <TableCell
//                     sx={{
//                       borderRight: "0.5px solid  #ccc",
//                       textAlign: "center",
//                     }}
//                   >
//                     Nos
//                   </TableCell>
//                   <TableCell>Amount</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {_.map(initialValue, (val, idx) => (
//                   <TableRow key={val.note} className={classes.tablrow} onClick={() => setActive(idx)}>
//                     <TableCell sx={{ borderRight: `1px solid #ccc` , }}className={classes.tblHeadCell}>{val.note}</TableCell>
//                     <TableCell sx={{ borderRight: `1px solid #ccc` ,}}>
//                         <TextField
//                         size="small"
//                         autoComplete="off"
//                         value={val.nos}
//                         onKeyPress={(e) => handleKey(e, idx)}
//                         inputRef={active === idx ? amtRef : null}
//                         InputProps={{
//                           style: {
//                             maxHeight: "10px",
//                             outline: "none",
//                             fontSize: 14,
//                           },
//                         }}
//                         inputProps={{ style: { textAlign: "right" } }}
//                         className={classes.tableInput}
//                         onChange={(e) => handleChange(e, idx)}
//                       />
//                     </TableCell>

//                     <TableCell align="right" padding="checkbox"sx={{ minWidth: 130, fontWeight: 700, padding: 0,height:"25px" }}>
//                       <Typography fontWeight={700} textAlign="right">{val.amt !== "" && parseFloat(val.amt).toFixed(2)}</Typography>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//                 <TableRow className={classes.tablrow} sx={{padding:0}}>
//                   <TableCell sx={{ borderRight: `1px solid #ccc` }} />
//                   <TableCell />
//                 </TableRow>
//                 <TableRow>
//                   <TableCell sx={{padding:"7px",height:"15px" ,borderLeft:"1px solid #ccc"}} colSpan={2}>Total</TableCell>
//                   <TableCell
//                     sx={{
//                       borderLeft: `1px solid #ccc`,
//                       textAlign: "right",
//                       fontWeight: 700,
//                       padding:"7px",height:"15px"
//                     }}
//                   >
//                     {parseFloat(totalAmt).toFixed(2)}
//                   </TableCell>
//                 </TableRow>
              
//               </TableBody>
//             </Table>
//           </TableContainer>
//           {errorMsg && <Typography color="error" className="my-2 flex justify-center">{errorMsg}</Typography>}
//           {/* <Typography color="error" className="my-2 flex justify-center">{errorMsg}</Typography> */}
//           <Grid className="my-2 flex justify-center">
          
//             <Button  onClick={handleTotalCheck}  disabled={postData.closing_expences_details.length === 0} sx={{backgroundColor: postData.closing_expences_details.length === 0 ? "#ccc" :"#A06EE1",color:"#fff !important",'&:hover': {
//       backgroundColor: postData.closing_expences_details.length === 0 ? 'darkgrey' : '#A06EE1', }}}>
//               Submit
//             </Button>
//           </Grid>
//         </Grid>
//         <Grid item xs={12} sm={6} md={6}>
//         <TableContainer className={classes.tblRoot} >
//           <Table className={classes.table}>
//               <TableHead className={classes.tblHeader} sx={{backgroundColor:"#A06EE1",color:"#fff"}}>
//                   <TableRow className={classes.tablrow} sx={{color:"#fff"}}>
//                   <TableCell className={classes.tblCell} sx={{color:"#fff"}}>S.No</TableCell>
//                   <TableCell className={classes.tblCell} sx={{color:"#fff"}}>Date</TableCell>
//                       <TableCell className={classes.tblCell} sx={{color:"#fff"}}>Bill No</TableCell>
//                       <TableCell className={classes.tblCell} sx={{color:"#fff"}}>Account Name</TableCell>
//                       <TableCell className={classes.tblCell} sx={{color:"#fff"}}>remarks</TableCell>
//                       <TableCell className={classes.tblCell} sx={{color:"#fff"}}>Amount</TableCell>
//                   </TableRow>
//               </TableHead>
//               <TableBody >
//               {
//               sideBardata.length > 0 ? (
//                   _.map(sideBardata, (value, idx) => (
//                       <TableRow className={classes.tablrow} key={idx}>
//                           <TableCell sx={{ borderLeft: "1px solid #ccc" }}>{idx + 1}</TableCell>
//                           <TableCell>{moment(value.docdate).format('DD-MM-YYYY')}</TableCell>
//                           <TableCell>{value.docno.replace(/_/g, "/")}</TableCell>
//                           <TableCell>{value.account_name}</TableCell>
//                           <TableCell>{value.remarks}</TableCell>
//                           <TableCell sx={{ fontWeight: 600, textAlign: "right !important" }}>
//                               {parseFloat(value.amount).toFixed(2)}
//                           </TableCell>
//                       </TableRow>
//                   ))
//               ) : (
//                   <TableRow>
//                       <TableCell colSpan={6} sx={{ textAlign: 'center' }}>
//                           No data found for today
//                       </TableCell>
//                   </TableRow>
//               )
//           }

//               </TableBody>
//           </Table>
//       </TableContainer>
//       <div
//             style={{
//               paddingInline: 5,
//               height: "100%",
//               display: "flex",
//               flexDirection: "column",
//               marginBlock:2,
//               justifyContent:"center"
//             }}
//           >
//                 <Grid className={classes.flexCorrection}>
//               <Typography fontWeight={600}>Opening Balance</Typography>
//               <TextField
//                 size="small"
//                 className={classes.TextFieldCash}
//                 inputProps={{
//                   style: {
//                     color: "#fff",
//                     textAlign: "right",
//                     fontWeight: "bold",
//                   }, 
//                 }}
//                 InputProps={{
//                   readOnly: true,
//                 }} 
//                 sx={{ backgroundColor: "#B57EDC" }}
//                 value={parseFloat(balance).toFixed(2)}
//                 onChange={openingBalanceChange}
//               />
//             </Grid>
//             <Grid className={classes.flexCorrection}>
//               <Typography fontWeight={600}>Expences Amount</Typography>
//               <TextField
//                 size="small"
//                 className={classes.TextFieldCash}
//                 inputProps={{
//                   style: {
//                     color: "#fff",
//                     textAlign: "right",
//                     fontWeight: "bold",
//                   }, // Set text color to white
//                 }}
//                 InputProps={{
//                   readOnly: true,
//                 }} 
//                 sx={{ backgroundColor: "#B57EDC" }}
//                 value={totalAmount}
//               />
//             </Grid>
        
//             <Grid className={classes.flexCorrection}>
//               <Typography fontWeight={600}>Closing Balance</Typography>
//               <TextField
//                 size="small"
//                 className={classes.TextFieldCash}
//                 inputProps={{
//                   style: {
//                     color: "#fff",
//                     textAlign: "right",
//                     fontWeight: "bold",
//                   }, 
//                 }}
//                 InputProps={{
//                   readOnly: true,
//                 }} 
//                 sx={{ backgroundColor: "#B57EDC" }}
//                 value={parseFloat((balance) - totalAmount).toFixed(2)}
//                 onChange={onClosingBalance}
//               />
//             </Grid>
//             </div>
        
//         </Grid>
//       </Grid>
//       <Dialog open={open}>
//     <DialogTitle>Cash CLose</DialogTitle>
//     <DialogContent>
//       <Typography>Are you sure want to close the Expense</Typography>
//     </DialogContent>
//     <DialogActions>
//       <Button variant="outlined" onClick={() => setOpen(false)}>No</Button>
//       <Button variant="contained" onClick={onSave}>Yes</Button>
//     </DialogActions>
//     </Dialog>
//     </Grid>
//   );
// };

// export default memo(ExpensesClose);
